import styled from '@emotion/styled'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { Button } from '../index'

const Banner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background: #262626;
  display: flex;
  justify-content: center;
  align-items: center;
`

const GameBannerEntry = observer((): JSX.Element => {
  const { t } = useTranslation()
  return (
    <Banner>
      <Button type="button" label={t('signIn')} onClick={() => {}} />
    </Banner>
  )
})

export default GameBannerEntry
